import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-morosidad-dialog',
  templateUrl: './edit-morosidad-dialog.component.html',
  styleUrls: ['./edit-morosidad-dialog.component.scss']
})
export class EditMorosidadDialogComponent {
  readonly dialogRef = inject(MatDialogRef<EditMorosidadDialogComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  public modificationForm = new FormGroup({
      creditor_rut: new FormControl(''),
      amount: new FormControl(''),
  })

  onNoClick(): void {
    this.dialogRef.close();
  }

  onModify() {
    const changes = this.modificationForm.value;
    console.log(changes);
    this.dialogRef.close({ creditor_rut: changes.creditor_rut, amount: changes.amount });
  }

  validateNumber(event: KeyboardEvent): void {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
}
